export const UTM_TERMS: string[] = [
  'utmMedium',
  'utmSource',
  'utmCampaign',
  'utmContent',
  'utmTerm'
];
